export const MILES_TO_KM = 1.60934;
export const FEET_TO_METERS = 0.3048;
export const SEC_PER_MILE_TO_SEC_PER_KM = 0.621371;

export function milesToKm(miles: number): number {
  return miles * MILES_TO_KM;
}

export function kmToMiles(km: number): number {
  return km / MILES_TO_KM;
}

export function feetToMeters(feet: number): number {
  return feet * FEET_TO_METERS;
}

export function metersToFeet(meters: number): number {
  return meters / FEET_TO_METERS;
}

export function formatPace(secPerMile: number | undefined, isMetric: boolean): string {
  if (!secPerMile) return '—';
  const spu = isMetric ? secPerMile * SEC_PER_MILE_TO_SEC_PER_KM : secPerMile;
  const m = Math.floor(spu / 60);
  const s = Math.floor(spu % 60);
  return `${m}:${String(s).padStart(2, '0')}/${isMetric ? 'km' : 'mi'}`;
}

export function formatDistance(miles: number | undefined, isMetric: boolean, decimals = 1): string {
  if (miles === undefined || miles === null) return '—';
  if (isMetric) return `${(miles * MILES_TO_KM).toFixed(decimals)} km`;
  return `${miles.toFixed(decimals)} mi`;
}

export function formatElevation(feet: number | undefined, isMetric: boolean): string {
  if (!feet) return '—';
  if (isMetric) return `${Math.round(feet * FEET_TO_METERS)} m`;
  return `${Math.round(feet)} ft`;
}

export function inputDistanceToMiles(value: number, isMetric: boolean): number {
  return isMetric ? kmToMiles(value) : value;
}

export function inputElevationToFeet(value: number, isMetric: boolean): number {
  return isMetric ? metersToFeet(value) : value;
}

export function milesToInputDisplay(miles: number, isMetric: boolean): number {
  return isMetric ? parseFloat((miles * MILES_TO_KM).toFixed(2)) : miles;
}

export function feetToInputDisplay(feet: number, isMetric: boolean): number {
  return isMetric ? parseFloat((feet * FEET_TO_METERS).toFixed(0)) : feet;
}
